<!--
 * @Descripttion: 
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2022-03-24 13:51:20
 * @LastEditors: Li Yong
 * @LastEditTime: 2022-03-25 15:39:45
-->
<template>
	<el-form :model="formData" label-width="130px" :rules="rules" ref="form">
		<el-form-item label="微信号">
			<el-input v-model="formData['wechat_id']" placeholder="请输入" maxlength="30" style="width: 400px"></el-input>
		</el-form-item>
		<el-form-item label="手机号" prop="phone_num">
			<el-input v-model="formData['phone_num']" placeholder="请输入" maxlength="11" style="width: 400px"></el-input>
		</el-form-item>
	</el-form>
</template>
<script>
import { isTel } from '@/utils/reg';
import mixin from '../../mixin';
export default {
	name: 'ContactForm',
	mixins: [mixin],
	data() {
		const validator = (rule, value, callback) => {
			if (value && !isTel.test(value)) {
				callback(new Error('手机号格式错误'));
			} else {
				callback();
			}
		};
		return {
			formData: {
				wechat_id: '',
				phone_num: '',
			},
			rules: {
				phone_num: [{ validator, message: '手机号格式错误', trigger: 'blur' }],
			},
		};
	},
	methods: {
		validate() {
			return new Promise((resolve, reject) => {
				this.$refs.form.validate(valid => {
					if (valid) {
						resolve(this.formData);
					} else {
						reject(valid);
						return false;
					}
				});
			});
		},
		resetForm() {
			this.$refs.form.resetFields();
		},
		isFormModified() {
			return this.isModified;
		},
	},
};
</script>